import styled, { css } from "styled-components";

export const AgGridContainer = styled.div`
    width: 100%;
    height: 50vh;

    .ag-theme-material .ag-header {
        background: #f2f2f2;
        text-align: center;
    }

    .ag-header-cell-label {
        justify-content: center;
    }

    .ag-row-style {
        justify-content: center;
    }
`;

export const AgGridContainerRow = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
`;
export const AgGridContentBox = styled.div`
    overflow: hidden;
    flex-grow: 1;
`;
export const ContainerOptions = styled.div`
    color: var(--neutralcolor-dark);
`;

export const Option = styled.span`
    font-weight: bold;
    color: var(--neutralcolor-medium);

    ${({ avaiable }) => {
        if (avaiable) {
            return css`
                cursor: pointer;
                color: var(--neutralcolor-dark);
                &:hover {
                    color: var(--managercolor-primary-dark);
                }
            `;
        }
    }}
`;
